import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from 'app/core/services/translate.service';

@Component({
  selector: 'itpx-communication-box',
  templateUrl: './communication-box.component.html',
  styleUrls: ['./communication-box.component.css']
})
export class CommunicationBoxComponent {

  @Input() config: CommBoxConfig;
  private message: string;
  constructor(
    private translateService: TranslateService
  ) { }
}

export class CommBoxConfig {
  title?: string;
  message?: string;
  domain?: any;
  actions?:{title: string, style: string, link: string[]}[];
  level: string = 'info';
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/common/communication-box/communication-box.component.ts